/**
 * Created by alex.y on 8/2/2017.
 */
import {
    AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output,
    ViewChild
} from "@angular/core";
import {NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgForm, NgModel} from "@angular/forms";
import {ValueAccessorBase} from "../../../objects/common/valueAccessorBase";
import {Location} from "../../../objects/management/locationManagement/location";

@Component({
    selector: 'location-form-input',
    templateUrl: './locationFormInput.component.html',
    moduleId: module.id.toString(),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: LocationFormInputComponent, multi: true}
    ],
})
export class LocationFormInputComponent extends ValueAccessorBase<any> implements OnInit, AfterViewInit {
    @Input() public name: string;
    @Input() public label: string;
    @Input() public disabled: boolean;
    @Input() public form: NgForm;
    @Input() public options: any = {};
    @Input() public inputLocation: Location;
    @Input() public placeholder: string = '';

    @Output() public inputEmitter: EventEmitter<Location> = new EventEmitter();

    public clonedLocation: Location = new Location();

    public hasAddressSelected: boolean = false;

    @ViewChild(NgModel) model: NgModel;

    public stringHelper = String;

    constructor(@Optional() @Inject(NG_VALIDATORS) private validators: Array<any>, @Optional() @Inject(NG_ASYNC_VALIDATORS) private asyncValidators: Array<any>) {
        super();
    }

    ngOnInit() {
        this.disabled = this.disabled || false;
    }

    ngAfterViewInit(): void {
        Object.assign(this.clonedLocation, this.inputLocation);

        this.model.control.setValidators(this.validators);
        this.model.control.setAsyncValidators(this.asyncValidators);
    }

    public parseAddress(type: string, address: any): string {
        return address.find((x: any) => x["types"].find((y: any) => y == type) != null);
    }

    public getAddress(place: Object): void {
        if (!place)
            return null;

        this.hasAddressSelected = true;

        let address = place["address_components"];

        if (!address)
            return null;

        let country = this.parseAddress("country", address);
        let state = this.parseAddress("administrative_area_level_1", address);
        let city = this.parseAddress("locality", address);

        if(!city)
            city = this.parseAddress("postal_town", address);

        let street = this.parseAddress("route", address);
        let building = this.parseAddress("street_number", address);
        let zip = this.parseAddress("postal_code", address);
        let admin = this.parseAddress("administrative_area_level_1", address);

        let name: string = '';

        let placeName = place["name"];
        let formattedAddr:string = place["formatted_address"];

        if (formattedAddr.indexOf(placeName) == -1)
            name = placeName;

        let resultStreet = "";

        if (!String.isNullOrEmpty(building))
            resultStreet += `${building["long_name"]} `;

        resultStreet += street ? street["long_name"] : "";

        if (admin && zip)
            zip = `${admin["short_name"]} ${zip["long_name"]}`;
        else if(zip)
            zip = zip["long_name"];

        this.inputLocation = (new Location({
            City: city ? city["long_name"] : "",
            Country: country ? country["long_name"] : "",
            Street: `${name ? name  : ''}${name && resultStreet ? ',' : ''}${resultStreet}`,
            Zip: zip ? zip : "",
            State: state ? state["long_name"] : "",
            Id: this.clonedLocation.Id,
            Created: this.clonedLocation.Created,
            Updated: this.clonedLocation.Updated,
            Type: this.clonedLocation.Type
        }));

        this.value = `${name ? name + ', ' : ''}${place["formatted_address"]}`;

        this.inputEmitter.emit(this.inputLocation);
    }

    public handleInput(): void {
        this.inputLocation = null;
        this.inputEmitter.emit(null);
    }
}


// WEBPACK FOOTER //
// ./app/components/common/locationFromInput/locationFormInput.component.ts